var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.751V3.56348L4.25 0.750977L8 3.56348V5.25098H15.5V15.751H0.5ZM2 14.251H3.5V12.751H2V14.251ZM2 11.251H3.5V9.75098H2V11.251ZM2 8.25098H3.5V6.75098H2V8.25098ZM2 5.25098H3.5V3.75098H2V5.25098ZM5 5.25098H6.5V3.75098H5V5.25098ZM5 14.251H14V6.75098H5V14.251ZM9.5 9.75098V8.25098H12.5V9.75098H9.5ZM9.5 12.751V11.251H12.5V12.751H9.5ZM6.5 9.75098V8.25098H8V9.75098H6.5ZM6.5 12.751V11.251H8V12.751H6.5Z",
    fill: "#9AA0A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/Company.ae93cdfd7bac4908f966a5c6ac4fe25c.svg";
export { ForwardRef as ReactComponent };